import { render } from "./contabilidadeView.vue?vue&type=template&id=47891582"
import script from "./contabilidadeView.vue?vue&type=script&lang=js"
export * from "./contabilidadeView.vue?vue&type=script&lang=js"

import "./contabilidadeView.vue?vue&type=style&index=0&id=47891582&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__